import { isApiErrorDto } from "../../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../../common/errors/isFetchBaseQueryError";

export const CHANGE_NOT_OPEN_TOAST = "change-not-open";

export const isChangeNotOpenRefusal = (e: unknown): boolean =>
  isFetchBaseQueryError(e) && isApiErrorDto(e.data) && e.data.errorCode === "zz_SourcingEventApiErrorCode_ChangeNotOpen";
